// extracted by mini-css-extract-plugin
module.exports = {"list":"HelpModal_list__syZn2","listItem":"HelpModal_listItem__34m_q","kbd":"HelpModal_kbd__RCRud"};